module.exports = __webpack_public_path__ + "static/media/32import-64.6b3a3770.xlsx";